<!-- Call Recordings popup -->
<app-loader *ngIf="loaderIcon | async"></app-loader>
<div class="modal fade" bsModal #CallRecordings="bs-modal" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-dialog-centered modal_80" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Call Recordings</h5>
        <button type="button" class="close" (click)="CallRecordings.hide()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div *ngIf="viewRight">
        <div class="modal-body">
          <div class="row mx-0">
            <div class="scroll_outer">
              <div class="large_scroll_inner">
                <ejs-grid #grid class="Table_Height_store table-striped table-ipad" height='480' [dataSource]='Calldata'
                          (rowSelected)='rowSelected($event, PlayCalltemplate);' [gridLines]='lines' [editSettings]="editSettings" allowFiltering='true'
                          [filterSettings]='filterSettings' allowSorting='true' [sortSettings]='sortOptions'
                          (created)="created($event)" (dataBound)='dataBound(grid)'>
                  <e-columns>
                    <e-column field='FacilityName' textAlign='Center' headerText='Store Name'
                              width='70'>
                      <ng-template #template let-data>
                        <span class="dataName1 dataName" [attr.title]="data.FacilityName">{{data.FacilityName}}</span>
                      </ng-template>
                    </e-column>
                    <e-column field='Campaign' textAlign='Center' headerText='Ad Source'
                              width='70'>
                      <ng-template #template let-data>
                        <span class="dataName1 dataName">{{data.Campaign}}</span>
                      </ng-template>
                    </e-column>
                    <e-column field='Route' textAlign='Center' headerText='Route'
                              width='40'>
                      <ng-template #template let-data>
                        <span class="dataName1 dataName">{{ data.Route }}</span>
                      </ng-template>
                    </e-column>
                    <e-column field='CallerID' headerText='Caller ID' width='40' textAlign='Center'>
                      <ng-template #template let-data>
                        <span class="dataName">{{getData(data.CallerID)}}</span>
                      </ng-template>
                    </e-column>
                    <e-column field='Tracking#' headerText='Tracking#' width='40' textAlign='Center'>
                      <ng-template #template let-data>
                        <span class="dataName">{{getData(data.TrackingNumber)}}</span>
                      </ng-template>
                    </e-column>
                    <e-column field='TimeOfDay' headerText='Time of Day' width='52' textAlign='Center'>
                      <ng-template #template let-data>
                        <span class="dataName">{{data.TimeOfDay}}</span>
                      </ng-template>
                    </e-column>
                    <e-column field='Duration' headerText='Duration' width='40' textAlign='Center' [sortComparer]='sortComparer'>
                      <ng-template #template let-data>
                        <span *ngIf="data.MissedCall" class="text-danger fw-bold">
                          Missed Call
                        </span>
                         <span *ngIf="data.VoiceMail" class="text-danger fw-bold">
                          Voice Mail
                        </span>
                        <span *ngIf="!data.MissedCall && !data.VoiceMail && (data.Duration == 0 || data.RecordingID?.startsWith('dum_') || (data.PhoneSystem === ePhoneSystem.Twilio && data.RecordingID?.startsWith('CA')))" class="text-danger fw-bold">
                         No Recording
                        </span>
                        <span *ngIf="!data.MissedCall && !data.VoiceMail && data.Duration > 0 && !data.RecordingID?.startsWith('dum_') && !(data.PhoneSystem === ePhoneSystem.Twilio && data.RecordingID?.startsWith('CA'))">
                          {{ data?.Duration | callduration }}
                        </span>
                      </ng-template>
                    </e-column>
                    <e-column field='PlayIcon' headerText='' width='20' textAlign='Center' [allowSorting]='false'>
                      <ng-template #template let-data>
                        <a *ngIf="!data.MissedCall && !data.VoiceMail && data.Duration > 0 && !data.RecordingID?.startsWith('dum_') && !(data.PhoneSystem === ePhoneSystem.Twilio && data.RecordingID?.startsWith('CA'))" class="play_icon imgCursor" id="playIcon"></a>
                      </ng-template>
                    </e-column>
                    <e-column  field='Relink' headerText='' width='30' textAlign='Center' [allowSorting]='false'>
                      <ng-template #template let-data>
                        <button class="btn btn-sm btn-primary" (click)="onRelinkClick($event, data)">Relink</button></ng-template>
                    </e-column> 
                  </e-columns>
                </ejs-grid>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="text-center my-5 py-5" *ngIf="!viewRight">
        <div class="alert alert-info mb-5">
          {{viewRightFalseMessage}}
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-primary me-3" data-bs-toggle="modal"
                (click)="CallRecordings.hide()">Cancel</button>
        <button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#GenerateReportDialog"
                [disabled]="disableGenerateReport()">Generate Report</button>
      </div>
    </div>
  </div>
</div>

<!--Call_record_emailing Pop up-->
<!-- <div class="modal fade" bsModal #PlayCalltemplate="bs-modal" tabindex="-1" role="dialog" data-backdrop="static"
data-bs-keyboard="false" aria-hidden="true"> -->
<ng-template #PlayCalltemplate>

  <div class="modal-header">
    <h5 class="modal-title">Call Recordings</h5>
    <button type="button" class="close" (click)="onAudioCancel()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form [formGroup]="sendEmailForm">
      <div class="row">
        <div class="col-2">Store Name</div>
        <div class="col-1">:</div>
        <div class="col-9">{{ StoreName }}</div>
      </div>
      <div class="row pt-1">
        <div class="col-2">Time</div>
        <div class="col-1">:</div>
        <div class="col-9 text-left">
          {{ selectedTimeOfDay}}
        </div>
      </div>
      <div class="py-2 w-100 mt-4" *ngIf="!viewRightForDownload">
        <app-loader-audio *ngIf="audioLoaderIcon | async" style="position: absolute;margin-left: 28px;margin-top: 30px;"></app-loader-audio>
        <audio controls style="width: 100%;" controlsList="nodownload" (loadeddata)="audioLoaded()">
          <source [src]="selectedAudioURL" type="audio/mpeg">
          Your browser does not support the audio element.
        </audio>
      </div>
      <div class="py-2 w-100 mt-4" *ngIf="viewRightForDownload">
        <app-loader-audio *ngIf="audioLoaderIcon | async" style="position: absolute;margin-left: 28px;margin-top: 30px;"></app-loader-audio>
        <audio controls style="width: 100%;" (loadeddata)="audioLoaded()">
          <source [src]="selectedAudioURL" type="audio/mpeg">
          Your browser does not support the audio element.
        </audio>
      </div>
      <div *ngIf="viewRightForEmail">
        <div class="row mb-2 ps-3">
          <label>Email Recording</label>
        </div>
        <div class="row email_attr">
          <div class="col-md-6 float-start">
            <label>To:<span class="required">*</span></label>
            <div class="float-start w-100">
              <input type="text" class="form-control" name="toEmail" [(ngModel)]="toEmailAddress"
                     [ngModelOptions]="{standalone: true}" [pattern]="emailPattern"  #toEmail="ngModel">
              <div class="alert alert-danger float-start"
                   *ngIf="toEmail.errors !== null &&(toEmail.dirty ||toEmail.touched)">
                <span *ngIf="toEmail.errors.pattern"> Enter valid E-Mail Id <br>
                </span>
              </div>
            </div>
          </div>
          <div class="col-md-6 float-start">
            <label>CC:</label>
            <div class="float-start w-100">
              <input type="text" class="form-control" name="ccEmail" [(ngModel)]="ccEmailAddress"
                     [ngModelOptions]="{standalone: true}" [pattern]="emailPattern"  #ccEmail="ngModel">
              <div class="alert alert-danger float-start"
                   *ngIf="ccEmail.errors !== null &&(ccEmail.dirty ||ccEmail.touched)">
                <span *ngIf="ccEmail.errors.pattern"> Enter valid E-Mail Id <br>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-3 mb-3 mx-0 mailing_info_notes">
          <div class="d-flex me-3">
            <label>Template <span class="required">*</span></label>
            <select class="form-select" [(ngModel)]="selectedEmailTemplate"
                    (change)="onChangeEmailTemplate($event.target.value)" style="width: 168px;">
              <option selected value="0" disabled>-Select-</option>
              <option [value]="emailTemp.LetterId" [selected]="emailTemp.DefaultTemplate"
                      *ngFor="let emailTemp of emailTemplates">
                {{emailTemp.LetterName}}
              </option>
            </select>
          </div>
        </div>

        <div class="row mx-0 ">
          <ejs-richtexteditor class="height400 mt-3" #defaultRTE [(value)]="rteValue">
          </ejs-richtexteditor>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-primary me-3" data-bs-toggle="modal"
            (click)="onAudioCancel()">Cancel</button>
    <button type="button" class="btn btn-primary" data-bs-dismiss="modal" *ngIf="viewRightForEmail" [disabled]="disableSendEmail()"
            (click)="sendEmail()">Send Email</button>
  </div>

</ng-template>
<!-- </div> -->

<div class="modal fade" id="GenerateReportDialog" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Generate Report</h5>
        <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="form-group"><b>Period</b></div>
        <div class="row">
          <div class="col-md-6">
            <label>From Date</label>
            <div class="inputbox">
              <ejs-datepicker class="form-control p-0 h-auto" format='MM/dd/yyyy' [min]="minPeriodFromDateCall"
                [max]="todaysdateCall" floatLabelType='Always' [(ngModel)]="periodFromDateCall"
                (change)="changeperiodFromDateCall($event.value)">
              </ejs-datepicker>
            </div>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-md-6">
            <label>To Date</label>
            <div class="inputbox">
              <ejs-datepicker class="form-control p-0 h-auto" format='MM/dd/yyyy' [min]="oldestDate" [max]="todaysdateCall"
                floatLabelType='Always' [(ngModel)]="periodToDateCall">
              </ejs-datepicker>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-primary me-3" data-bs-dismiss="modal">Cancel</button>
        <button type="button" class="btn btn-primary" data-bs-dismiss="modal" (click)="onCallReportView()">Ok</button>
      </div>
    </div>
  </div>
</div>
